import Vue from 'vue';
import './assets/style/materialdesignicons.min.css';
import VueLodash from 'vue-lodash';
import Modernizr from 'modernizr'; // eslint-disable-line no-unused-vars
import browser from 'browser-detect';
import lodash from 'lodash';
import Buefy, { SnackbarProgrammatic as Snackbar } from 'buefy';
import VTooltip from 'v-tooltip';
import Modern from '@/plugin/ModernDialog';
import CleaveDirective from './directives/cleave';
import disableBrowsers from '../.browserrc.json'; // eslint-disable-line import/extensions
import App from './App.vue';
import router from './router';
import store from './store';
import axios from './api/client';
import './validator';
import './assets/style/custom.scss';
import './assets/style/fontawesome.css';
import './assets/style/main.styl';
import './assets/style/modern/modern.styl';
import './filters';
import { refresh } from './api/auth';
import { LOGOUT_AND_CLEAR_STATE } from './store/actions';
import { SET_SPLASH } from './store/mutations';

Vue.config.productionTip = false;
Vue.use(Buefy, {
  defaultNoticeQueue: false,
});
Vue.use(Modern);

Vue.use(VTooltip, {
  defaultTrigger: 'hover focus click',
  defaultTemplate: '<div class="modern-tooltip" role="tooltip"><div class="modern-tooltip-arrow"></div><div class="modern-tooltip-inner"></div></div>',
  defaultArrowSelector: '.modern-tooltip-arrow, .tooltip__arrow',
  defaultInnerSelector: '.modern-tooltip-inner, .tooltip__inner',
});
Vue.use(VueLodash, { name: null, lodash });
Vue.directive('cleave', CleaveDirective);

axios.interceptors.response.use(
  (response) => response,
  // eslint-disable-next-line consistent-return
  (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 500) {
      Snackbar.open({
        type: 'is-danger',
        message: 'Something went wrong. Please try again later or contact support.',
        position: 'is-top',
        indefinite: true,
        actionText: ' ',
      });
    }

    // if refresh failed dispatch logout
    if (error.response && error.response.status !== 200 && originalRequest.url === '/refresh') {
      store.commit(SET_SPLASH, true);
      window.location = '/login';
      return store.dispatch(LOGOUT_AND_CLEAR_STATE)
        .then(() => { store.commit(SET_SPLASH, false); });
    }

    // if request unauthorized try refresh token and repeat request
    if (error.response.status === 401 && !originalRequest.isRetry) {
      originalRequest.isRetry = true;
      return refresh()
        .then((response) => {
          if (!response) {
            store.commit(SET_SPLASH, true);
            window.location = '/login';
            store.dispatch(LOGOUT_AND_CLEAR_STATE)
              .then(() => { store.commit(SET_SPLASH, false); });
          }
          return axios(originalRequest)
            .catch((responseOrigReq) => {
              if (responseOrigReq.response && responseOrigReq.response.status !== 200) {
                if (responseOrigReq.response.status === 401) {
                  store.commit(SET_SPLASH, true);
                  window.location = '/login';
                  store.dispatch(LOGOUT_AND_CLEAR_STATE)
                    .then(() => { store.commit(SET_SPLASH, false); });
                } else {
                  window.location = '/';
                }
              }
            });
        });
    }

    // if forbidden status
    if (error.response && error.response.status === 403) {
      if (error.response?.data?.error && error.response.data.error === 'account_closed') {
        window.location = '/closed-account';
      } else if (window.location.pathname === '/login') {
        setTimeout(() => {
          window.location = '';
        }, 2000);
      } else {
        window.location = '';
      }
    }

    throw error;
  },
);

axios.interceptors.request.use(
  (config) => {
    const updateConfig = config;
    if (store.getters.isSwitched) {
      // now work after switch, first request (/user/<%= id %>) send without header
      updateConfig.headers['Switch-User-Id'] = store.state.user.id;
    }
    return updateConfig;
  },
  (error) => error,
);

if (!Modernizr.cookies) {
  Snackbar.open({
    type: 'is-danger',
    message: 'Cookies are disabled in your browser. Please enable cookies to allow normal functionality. You can enable them in your browser settings',
    position: 'is-top',
    indefinite: true,
  });
}

const browserInfo = browser();
const disableBrowser = disableBrowsers
  .filter((disableBrowserInfo) => disableBrowserInfo.name.toLowerCase() === browserInfo.name.toLowerCase()) // eslint-disable-line max-len
  .pop();

if (disableBrowser) {
  if (disableBrowser.min > browserInfo.versionNumber) {
    Snackbar.open({
      type: 'is-danger',
      message: 'Try a different browser! The browser you are using has limited functionality. For the full experience, we recommend using a different browser',
      position: 'is-top',
      indefinite: true,
    });
  }
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
